<script>

  import FairnessMeasure from "./Components/FairnessMeasure.svelte";
  import { margin } from "./store";

  function resizeMarginOnResize() {
    const mobile = window.innerWidth <= 1000;
    $margin = {
      top: mobile ? 65 : 65,
      bottom: mobile ? 20 : 10,
      left: mobile ? 50 : 80,
      right: 10,
    };
  }
  resizeMarginOnResize();
</script>

<svelte:window on:resize={resizeMarginOnResize} />
<FairnessMeasure />
